import axios from 'axios';
import { GET, POST, uwBaseUrl } from '../../../../../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../../../../../utils/dateUtils';
import { TENURE } from '../../../../../../../store/dashboard/auditedFinancials/constants';
import { MIS_TYPE_PROVISIONAL_STATEMENTS } from '../../../../AuditedFinancialsVisualisation/auditedStatementLayout';
import { FINANCIALS_FILE_TYPE } from '../../../financialsIngestion/constants';
import { UeEnvelope } from '../../../../../../../utils/uwResponse';
import { PROVISIONAL_FILE_ENDPOINTS } from './constants';
import { FetchProvisionalFileStatementParams, ProvisionalFileItem, ProvisionalFileStatementData } from './types';

export function getProvisionalFiles(orgId: string) {
    return axios<UeEnvelope<ProvisionalFileItem[]>>({
        baseURL: uwBaseUrl,
        url: PROVISIONAL_FILE_ENDPOINTS.FILE_LIST,
        method: GET,
        params: { orgId, fileType: FINANCIALS_FILE_TYPE.PROVISIONAL },
    });
}

export function fetchProvisionalFileStatement({ orgId, docId, mis, nature }: FetchProvisionalFileStatementParams) {
    return axios<UeEnvelope<ProvisionalFileStatementData>>({
        baseURL: uwBaseUrl,
        url: PROVISIONAL_FILE_ENDPOINTS.FILE_STATEMENT,
        method: POST,
        data: {
            orgId,
            type: MIS_TYPE_PROVISIONAL_STATEMENTS,
            requestId: getTimeStamp(),
            mis,
            raw: false,
            tenure: TENURE.YEARLY,
            docId,
            ...(nature ? { nature } : {}),
        },
    });
}
